import type { ExpenseSource, PersonalExpenseSource, WithdrawalSource } from '@six-pockets/shared';
import type { SegmentOption } from '@/components/ui';

export const SOURCE_LABEL: Record<ExpenseSource, string> = {
  counter: 'Cash counter',
  staff: 'Staff',
  sai: 'Sai',
  bharath: 'Bharath',
  waiver: 'Waived balance',
};

/** What staff pick from when adding an expense. 'waiver' isn't one: those are made by Pay now (status Waived). */
export type PickableSource = Exclude<ExpenseSource, 'waiver'>;

export const SOURCE_OPTIONS: SegmentOption<PickableSource>[] = (['counter', 'staff', 'sai', 'bharath'] as const).map((s) => ({
  value: s,
  label: SOURCE_LABEL[s],
}));

/** Where a withdrawal is taken from. */
export const WITHDRAWAL_LABEL: Record<WithdrawalSource, string> = { counter: 'Cash counter', bank: 'Bank' };

export const WITHDRAWAL_OPTIONS: SegmentOption<WithdrawalSource>[] = (Object.keys(WITHDRAWAL_LABEL) as WithdrawalSource[]).map((s) => ({
  value: s,
  label: WITHDRAWAL_LABEL[s],
}));

/** The people who pay for the business and withdraw it later, in the order the summary shows them. */
export const PEOPLE: PersonalExpenseSource[] = ['sai', 'bharath', 'staff'];
